import { ClearRounded, EditRounded } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Alert, Dialog, Table } from "../../layout";
import AddEditCat from "./AddEditCat";
import * as actions from "../../api/actions/pos";
import { useContext } from "react";
import { AppContext } from "../../App";
import { useEffect } from "react";
import { endpoints } from "../../api/actions/api";
import { t } from "i18next";

const ExpnsCat = (props) => {
  const { _list, _get, _clear, _type, _delete } = props;
  const [showForm, setShowForm] = useState(false);
  const [updData, setUpdData] = useState();
  const { setLoader, setPageTitle, authUser } = useContext(AppContext);
  const [access, setAccess] = useState({});
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setPageTitle(t("expenseCategories"));
    setLoader(true);
    _get(endpoints.ExpenseCat, actions.ActionType.List, () => setLoader(false));
    return () => {
      _clear();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      authUser &&
      authUser.featuresAccess &&
      authUser.featuresAccess.expenseCategory
    )
      setAccess({ ...authUser.featuresAccess.expenseCategory });
    return () => {};
  }, [authUser]);

  const handleAddEdit = (val) => {
    setUpdData(val);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("dltSuccessTitle"),
      subTitle: t("catDltTitle"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("dltSuccessTitle"),
              subTitle: res.msg,
            });
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: t("warning"),
              subTitle: res.msg,
            });
          }
        };
        _delete(
          endpoints.ExpenseCat,
          id,
          actions.ActionType.RmvList,
          onComplete
        );
      },
    });
  };

  const ActionComp = (props) => (
    <Box>
      {access.isHaveEditAccess && (
        <Tooltip arrow title={t("edit")}>
          <IconButton
            onClick={() => handleAddEdit(props)}
            size="small"
            className="btn-primary mr-5"
          >
            <EditRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
      {access.isHaveDeleteAccess && (
        <Tooltip arrow title={t("delete")}>
          <IconButton
            onClick={() => handleDlt(props.id)}
            size="small"
            className="error-color"
          >
            <ClearRounded className="fs-18 m-2" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );

  const HeaderComp = () =>
    access.isHaveAddAccess ? (
      <Button
        onClick={() => handleAddEdit()}
        className="btn-secondary"
        sx={{
          width: { md: "180px", xs: "100%" },
          mb: { xs: "10px", md: "0px" },
          fontSize: "17px",
          padding: "8px",
        }}
      >
        {t("addExpense")}
      </Button>
    ) : (
      <></>
    );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "actions", label: t("actions") },
          { id: "name", label: t("expenseName") },
          { id: "descr", label: t("description") },
        ]}
        tblData={
          _type === "expenseCats" ||
          _type === "postExpenseCat" ||
          _type === "putExpenseCat"
            ? _list
            : []
        }
      />
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Edit Dialog */}
      {showForm && (
        <Dialog show={showForm} onClose={false}>
          <AddEditCat {...{ updData, setShowForm }} />
        </Dialog>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  _list: state.pos.list,
  _type: state.pos.type,
});

const mapActionToProps = {
  _get: actions.get,
  _delete: actions.Delete,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(ExpnsCat);
